import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installDevErrorLogger } from "./lib/devErrorLogger";

installDevErrorLogger();

createRoot(document.getElementById("root")!).render(<App />);
